import { render, staticRenderFns } from "./OffMarketListings.vue?vue&type=template&id=b857c6d4&scoped=true&"
import script from "./OffMarketListings.vue?vue&type=script&lang=ts&"
export * from "./OffMarketListings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b857c6d4",
  null
  
)

export default component.exports